import { SpacingVariants, spacing } from '~/base'

type Props = React.ComponentPropsWithoutRef<'div'> & SpacingVariants

export function Spacing({ margin, children }: Props) {
  return <div className={spacing({ margin })}>{children}</div>
}
